import { Box, Container, CreateHeaders, HeaderSizeEnum, Skeleton, booleanHeader, currencyHeader, dateHeader, textHeader } from '@frontend-workspace/react-shared-lib';
import styles from './admin-all-companies.module.scss';
import { Col, Row } from 'reactstrap';
import PageTitle from '../page-title/page-title';
import WebkuaTable from '../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';
import { useGetRequestNewHook, useTableConfigHook } from '../requestUtils';
import { useState } from 'react';

/* eslint-disable-next-line */
export interface AdminAllCompaniesProps { }

interface IAllCompanies {
  isActive: boolean;
  companyNumber: string;
  companyName: string;
  department: string;
  adminEmail: string;
  licenseNumbers: number[];
  productNames: string[];
  productIds: string[];
  monthlyValueOfLicenses: number;
  yearlyValueOfLicenses: number;
}
export function AdminAllCompanies(props: AdminAllCompaniesProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("adminCompanies");
  const [onlyActive, setOnlyActive] = useState(true);
  const { data: users, isLoading }: { data: IAllCompanies[], isLoading: boolean } = useGetRequestNewHook(`companies/action/detailed`, []);
  const handleOnlyActiveToggle = () => setOnlyActive(!onlyActive);
  const headers = CreateHeaders([
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("companyName", t("standard.customerName"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("department", t("standard.department"), HeaderSizeEnum.MEDIUM),
    textHeader("adminId", "Admin. ID", HeaderSizeEnum.MEDIUM),
    textHeader("companyContact", t("basicCustomerDetails.customerContact"), HeaderSizeEnum.MEDIUM),
    textHeader("licenseNumbers", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("productNames", t("standard.products"), HeaderSizeEnum.MEDIUM),
    textHeader("productIds", t("standard.productID"), HeaderSizeEnum.MEDIUM),
    textHeader("numberOfAccounts", t("standard.numberOfUsers"), HeaderSizeEnum.MEDIUM),
    textHeader("companyGroupId", t("standard.companyGroupID"), HeaderSizeEnum.MEDIUM),
    currencyHeader("monthlyValueOfLicenses", t("standard.monthlyValueOfLicenses"), HeaderSizeEnum.MEDIUM),
    currencyHeader("yearlyValueOfLicenses", t("standard.yearlyValueOfLicenses"), HeaderSizeEnum.MEDIUM),
    booleanHeader("isActive", t("standard.active"))
  ]);
  const filteredCompanies = users.filter(u => {
    if (onlyActive) {
      return u.isActive;
    }
    return true;
  });
  return (
    <Row>
      <Col>
        {!filteredCompanies ?
          <>
            <div className='d-flex justify-content-end'>
              <Skeleton animation="wave" width={150} height={50} />
            </div>
            <Skeleton variant="rectangular" animation="wave" width='100%' height={1100} />
            <div className='d-flex justify-content-end'>
              <Skeleton animation="wave" width={150} height={50} />
            </div></> :
          <>
            <h4 className='mt-5 mb-3 mb-sm-0 MuiTypography-h5'>{t("standard.allCompanies")}</h4>
            <WebkuaTable
              headers={headers}
              tableFilters={[
                {
                  label: t("standard.activeOnly"),
                  checked: onlyActive,
                  onChange: handleOnlyActiveToggle
                }
              ]}
              isLoading={isLoading}
              data={filteredCompanies}
              tableConfig={tableConfig}
            />
          </>
        }
      </Col>
    </Row>
  );
}

export default AdminAllCompanies;
